import React, { ChangeEvent } from 'react';
import { useTranslation } from 'react-i18next';
import { IconSearch } from '../../../../assets/icons/icon-search';
import { Header, InputMui, NavHeader, Page, SubmitButton } from '../../../../components';
import RadiosGroup from '../../../../components/radios-group';
import { useTimeZones } from '../../hooks/use-time-zones';

type TimeZonesListProps = {
  onChange: (e: ChangeEvent<HTMLInputElement>) => void;
  value: string;
  handleClose: () => void;
  handleSave: () => void;
};

const TimeZonesList: React.FC<TimeZonesListProps> = ({ onChange, value, handleClose, handleSave }) => {
  const { t } = useTranslation('installation');
  const { t: tc } = useTranslation('common');
  const { timeZonesOptions, inputValue, setInputValue } = useTimeZones();

  const handleChange = (event: ChangeEvent<HTMLInputElement>) => setInputValue(event.target.value);

  return (
    <Page
      kind="above"
      header={
        <>
          <NavHeader onClick={handleClose} />
          <Header title={t('time_zone')} />
        </>
      }
    >
      <InputMui
        value={inputValue}
        placeholder={tc('search')}
        onChange={handleChange}
        startIcon={<IconSearch />}
        clearEnabled
      />
      <RadiosGroup options={timeZonesOptions} value={value} onChange={onChange} transparent />
      <SubmitButton type="button" onClick={handleSave} />
    </Page>
  );
};

export default TimeZonesList;
